// Constants extracted from Footer.tsx to keep component focused on structure.
// Provides skeleton layout definitions for facebookPost Footer (non-loading visual skeleton section).

import type { PostPreviewSizes } from '../../types';

export type FooterSkeletonSizeMap = Readonly<Record<PostPreviewSizes, string>>;

const sizeMap = (small: string, medium: string, large: string): FooterSkeletonSizeMap => ({
	xsmall: '',
	small,
	medium,
	large,
});
const rect = (key: string, sizes: FooterSkeletonSizeMap) => ({ key, sizes }) as const;

const profileRectangles = [
	rect('profileSkeleton-rect-1', sizeMap('h-[3px] w-[65px]', 'h-1.5 w-[143px]', 'h-2 w-[160px]')),
	rect('profileSkeleton-rect-2', sizeMap('h-[3px] w-[36px]', 'h-1.5 w-[80px]', 'h-2 w-[90px]')),
] as const;

const paragraphRectangles = [
	rect('paragraphSkeleton-rect-1', sizeMap('h-[5px] w-[80px]', 'h-2 w-[170px]', 'h-2.5 w-[187px]')),
	rect('paragraphSkeleton-rect-2', sizeMap('h-[5px] w-[90px]', 'h-2 w-[190px]', 'h-2.5 w-[205px]')),
] as const;

export const footerShapes = {
	profileSkeleton: {
		styles: sizeMap('gap-[3px] pt-3 px-[3px]', 'gap-1.5 pt-5 px-[5px]', 'gap-1.5 pt-6 px-[7px]'),
		circle: { sizes: sizeMap('h-6 w-6', 'h-7 w-7', 'h-6 w-6') },
		rectangles: { styles: sizeMap('gap-0.5', 'gap-1', 'gap-1'), shapes: profileRectangles },
	},
	paragraphSkeleton: {
		styles: sizeMap('gap-0.5 pt-2 px-[3px]', 'gap-[3px] pt-3 px-[5px]', 'gap-1 pt-[14px] px-[7px]'),
		rectangles: paragraphRectangles,
	},
	imageSkeletonContainer: { styles: sizeMap('mt-1.5', 'mt-2.5', 'mt-3') },
	imageSkeleton: { styles: sizeMap('h-[53px] w-full', 'h-[105px] w-full', 'h-[123px] w-full') },
	imageSkeletonOverlay: {
		styles: sizeMap(
			'absolute top-0 left-0 right-0 bottom-0 m-auto h-[21px] w-[23px]',
			'absolute top-0 left-0 right-0 bottom-0 m-auto h-[42px] w-[46px]',
			'absolute top-0 left-0 right-0 bottom-0 m-auto h-[50px] w-[54px]',
		),
	},
} as const;
